import { MetaBillingsTaxiTaxiStatusCountersResponseData } from "../../../../../api/raily/meta/billings/taxi-taxi/status-counters/meta-billings-taxi-taxi-status-counters.response";
import MetaBillingsTaxiTaxiStatusCounters from "./meta-billings-taxi-taxi-status-counters";

const create = (
  data: MetaBillingsTaxiTaxiStatusCountersResponseData,
): MetaBillingsTaxiTaxiStatusCounters => {
  return {
    accepted: data.accepted,
    created: data.created,
    rejected: data.rejected,
    reopened: data.reopened,
    reopenRequest: data.reopenRequest,
  };
};

const metaBillingsTaxiTaxiStatusCountersFactory = { create };

export default metaBillingsTaxiTaxiStatusCountersFactory;
